"use client";

import { useCallback, useEffect, useRef, useState } from "react";

/**
 * คง type ของ modal ไว้ระหว่าง exit animation — กัน parent unmount ก่อน bounce-out จบ
 */
export function useStickyModalHost<T extends string>(active: T | null) {
  const [displayed, setDisplayed] = useState<T | null>(active);
  const activeRef = useRef(active);
  activeRef.current = active;

  useEffect(() => {
    if (active) setDisplayed(active);
  }, [active]);

  const onExited = useCallback(() => {
    if (!activeRef.current) setDisplayed(null);
  }, []);

  return {
    displayed,
    isOpen: active !== null,
    onExited,
  };
}
